import { render, staticRenderFns } from "./PlatManage.vue?vue&type=template&id=094f71c2&scoped=true&"
import script from "./PlatManage.vue?vue&type=script&lang=js&"
export * from "./PlatManage.vue?vue&type=script&lang=js&"
import style0 from "./PlatManage.vue?vue&type=style&index=0&id=094f71c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094f71c2",
  null
  
)

export default component.exports